<template>
  <div>
    <b-alert :show="trafficAlert"
             variant="danger"
            @dismissed="trafficAlert=false"
             dismissible>
      <h4 class="alert-heading">Traffic alert!</h4>
      Things have changed since you began drafting your reply. Check the updates below before you send!
    </b-alert>
    <b-alert :show="undoCountdown"
             variant="info"
             @dismissed="dismissUndoAlert"
             @dismiss-count-down="countDownChanged"
             dismissible>
      <span class="alert-heading">Sending... <a href="#" @click="undoSend">Undo</a></span>
      <b-progress variant="warning"
                  :max="dismissSecs"
                  :value="undoCountdown"
                  height="4px">
      </b-progress>
    </b-alert>
    <b-form class="new-message-form text-left" @submit.stop.prevent="handleSubmit">
      <div class="new-message-row">
        <label>Recipient</label>
        <v-select type="email" v-model="toEmail" :options="customerCollection" placeholder="to" taggable multiple push-tags/>
      </div>
      <div v-if="!forwardedMessage" class="new-message-row">
        <label>cc</label>
        <v-select type="email" v-model="cc" :options="customerCollection" placeholder="cc" taggable multiple push-tags/>
      </div>
      <div v-if="(!parentMessage && !forwardedMessage) || (parentMessage && !parentMessage.source_id)" class="new-message-row">
        <label>Subject</label>
        <b-form-input type="text"
                      required
                      placeholder="subject"
                      v-model="subject">
        </b-form-input>
      </div>
      <at :members="atlist">
        <div id="toolbar">
          <button class="ql-image" @click="customImageHandler($event)"></button>
          <button class="ql-attachment" @click="messageAttachmentHandler()"></button>
          <button class="ql-bold"></button>
          <button class="ql-italic"></button>
          <button class="ql-underline"></button>
          <button class="ql-strike"></button>
          <span class="ql-formats">
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
          </span>
          <button class="ql-link"></button>
          <span :key="initialKey" class="ql-formats">
           <select v-model="selectedResponse" @change="savedRepliesHandler(selectedResponse)" class="ql-saved-replies">
             <option v-for="savedResponse in savedResponses" :key="savedResponse.id" :value="savedResponse.id">{{savedResponse.name}}</option>
             <option value=0>Save Response</option>
           </select>
          </span>
        </div>
        <quill-editor v-show="renderEditor" v-model="content" ref="messageQuillEditor" :options="editorOption" @ready="onEditorReady($event)" @input="autoSaveDraft()"></quill-editor>
        <div class='editorSignature' v-html="currentUser.messageSignature"></div>
      </at>
      <Attachments v-if="messageForm.attachments.length > 0" :attachments="messageForm.attachments" :controls="true"/>
      <div class="row new-message-actions">
        <div class="col-sm-12 col-md-4 new-message-buttons">
          <b-button class="message-button-item" variant="primary" type="submit">{{submitButtonText}}</b-button>
          <b-button class="message-button-item" variant="outline-info" @click="saveDraft(false)">{{draftButtonText}}</b-button>
          <b-button class="message-button-item" variant="outline-danger" @click="discardDraft">Discard</b-button>
          <span class="draft-saved message-button-item" v-if="showAutoSaveIcon" v-b-tooltip.right title="Saved!"><fa icon="check-circle"/></span>
        </div>
        <ul class="col-sm-12 col-md-4 change-user-status">
          <li>
            <label>Status:</label>
            <v-select class="inline-v-select" v-model="messageStatus" :options="statuses" />
          </li>
          <li>
            <SingleUserSelector class="inline-user-select" v-on:user-change="setUser($event)" v-on:user-remove="setUser({id: null})" :parent="messageForm" :parentPath="'messageForm'"/>
          </li>
        </ul>
      </div>
    </b-form>
    <input hidden multiple type="file" id="messageAttachment" @change="uploadAttachment($event)" />
    <input hidden type="file" id="quillImage" @change="saveImage($event)" />
    <SaveReplyTemplate v-if="mailboxPresent" :mailbox="mailbox.id" />
  </div>

</template>

<script>
import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { collectionsMixins } from '@/mixins/collectionsMixins'
import Delta from 'quill-delta'
import Attachments from './Attachments'
import SingleUserSelector from './selectors/users/SingleUserSelector.vue'
import SaveReplyTemplate from './SaveReplyTemplate'
export default {
  name: 'NewMessage',
  mixins: [collectionsMixins],
  props: ['mailbox', 'parentMessage', 'updates', 'parent'],
  data () {
    var vm = this
    return {
      editor: Object,
      editorOption: {
        modules: {
          imageResize: true,
          toolbar: {
            container: '#toolbar',
            handlers: {
              'image': function () { return false },
              'saved-replies': function (value) { vm.savedRepliesHandler(value) }
            }
          }
        },
        mailboxObject: Object
      },
      editorContent: '',
      renderEditor: false,
      savedResponses: [],
      submitButtonText: 'Send',
      draftButtonText: 'Save draft',
      customerCollection: [],
      statuses: ['active', 'pending', 'closed'],
      trafficAlert: false,
      editorRange: null,
      undo: false,
      dismissSecs: 5,
      undoCountdown: 0,
      showAutoSaveIcon: false,
      dontSaveDraft: false,
      selectedResponse: 0,
      initialKey: 0,
      textSelection: {}
    }
  },
  components: {
    Attachments,
    SingleUserSelector,
    SaveReplyTemplate
  },
  created () {
    this.$root.$on('toggleReply', this.getParentData)
    this.setDefaultMessageForm()
    this.getSavedReplies()
    if (this.parentMessage && this.parent !== 'modal') {
      this.getParentData()
    } else if (this.forwardedMessage) {
      this.composeForwardedMessage()
    } else {
      this.resetMessage()
    }
    this.customersCollection()
    this.updateMessageForm({mailbox_id: this.mailbox.id})
  },
  computed: {

    ...mapGetters(['message', 'forwardedMessage', 'currentUser', 'atlist', 'draft', 'messageForm', 'draftForm', 'currentInbox']),

    mailboxPresent: function () {
      return this.mailbox && this.mailbox.id
    },

    toEmail: {
      get () {
        return this.messageForm.to_email
      },
      set (value) {
        this.updateMessageForm({to_email: value})
      }
    },

    cc: {
      get () {
        return this.messageForm.cc
      },
      set (value) {
        this.updateMessageForm({cc: value})
      }
    },

    subject: {
      get () {
        return this.messageForm.subject
      },
      set (value) {
        this.updateMessageForm({subject: value})
      }
    },

    content: {
      get () {
        return this.editorContent
      },
      set (value) {
        this.updateMessageForm({content: value})
      }
    },

    messageStatus: {
      get () {
        return this.messageForm.status
      },
      set (value) {
        this.updateMessageForm({status: value})
      }
    }

  },

  methods: {
    ...mapMutations(['setNewDraft', 'setDefaultDraft', 'updateMessageForm', 'setDefaultMessageForm', 'setSendingStatus']),
    ...mapActions(['createDraft', 'updateDraft', 'deleteDraft', 'saveDraftMessage', 'sendMessage', 'reloadMessage']),

    // REFACTOR user selector to support v-model
    setUser (value) {
      this.updateMessageForm({user: value})
    },

    composeForwardedMessage () {
      if (this.message && this.message.id) {
        let forwardedContent = '---------- Forwarded message ---------</br>'
        this.message.message_threads.map(thread => {
          forwardedContent += thread.body_html
        })
        this.updateMessageForm({
          content: forwardedContent,
          subject: `FWD: ${this.message.subject}`,
          mailbox_id: this.message.mailbox_id
        })
        this.editorContent = forwardedContent
      }
    },

    onEditorReady (quill) {
      this.editor = quill
      this.editor.root.addEventListener('drop', this.saveDroppedImage, false)
      this.editor.root.addEventListener('paste', this.savePastedImage, false)
      this.loadSavedReplies()
      if (this.textSelection.index) {
        this.editor.focus()
        this.editor.setSelection(this.textSelection)
      }
    },

    getSavedReplies () {
      this.renderEditor = false
      var mailboxId
      if (this.parentMessage) {
        mailboxId = this.parentMessage.mailbox.id
      } else {
        mailboxId = this.mailbox.id
      }
      this.$http.get('/mailboxes/' + mailboxId + '/saved_replies')
        .then(response => {
          this.savedResponses = response.data
          this.initialKey++
          this.renderEditor = true
        })
        .catch(e => { console.log(e) })
    },

    savedRepliesHandler (value) {
      if (value === '0') {
        this.$root.$emit('saveReply', this.messageForm.content)
      } else {
        let replyContent = this.savedResponses.find(rep => rep.id === parseInt(value))
        if (this.message.customer) {
          let fullName = this.message.customer.name
          let firstName = fullName ? fullName.split(' ')[0] : ''
          this.editorContent = replyContent.content.replace('{{customer}}', firstName)
        } else {
          this.editorContent = replyContent.content
        }
        this.updateMessageForm({content: replyContent.content})
      }
    },

    loadSavedReplies () {
      const placeholderPickerItems = Array.prototype.slice.call(document.querySelectorAll('.ql-saved-replies .ql-picker-options .ql-picker-item'))
      placeholderPickerItems.forEach(function (item) {
        item.textContent = item.dataset.label
        item.innerText = item.dataset.label
      })
      document.querySelector('.ql-saved-replies .ql-picker-label').innerHTML = ''
    },

    uploadAttachment (e) {
      for (var i = 0; i < e.target.files.length; i++) {
        var formData = new FormData()
        formData.append('attachment[file]', e.target.files[i])
        this.$http.post('/uploads', formData, { headers: {'Content-Type': 'multipart/form-data'} })
          .then(response => {
            let attachments = this.messageForm.attachments
            attachments.push({
              name: response.data.attachment_name,
              url: response.data.attachment_url,
              id: response.data.id,
              size: response.data.size,
              image: response.data.image,
              document: response.data.document
            })
            this.updateMessageForm({
              attachments: attachments
            })
            document.getElementById('messageAttachment').value = ''
          })
          .catch(e => {
            alert('Attachment failed to upload. Check file and try again.')
          })
      }
    },

    messageAttachmentHandler () {
      document.getElementById('messageAttachment').click()
    },

    customImageHandler (event) {
      document.getElementById('quillImage').click()
    },

    saveDroppedImage (event) {
      event.preventDefault()
      if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
        this.uploadImage(event.dataTransfer.files[0])
      }
    },

    savePastedImage (event) {
      if (event.clipboardData && event.clipboardData.items && event.clipboardData.items.length) {
        let items = event.clipboardData && event.clipboardData.items
        for (let i = 0; i < items.length; i++) {
          if (items[i].kind === 'file') {
            this.uploadImage(items[i].getAsFile())
          }
        }
      }
    },

    saveImage (e) {
      this.uploadImage(e.target.files[0])
    },

    uploadImage (file) {
      var formData = new FormData()
      formData.append('attachment[file]', file)
      this.$http.post('/uploads', formData, { headers: {'Content-Type': 'multipart/form-data'} })
        .then(response => {
          this.editorRange = this.editor.getSelection()
          this.editor.updateContents(new Delta()
            .retain(this.editorRange.index)
            .delete(this.editorRange.length)
            .insert({image: response.data.attachment_url})
          )
          document.getElementById('quillImage').value = ''
        })
        .catch(e => {
          console.error(e)
        })
    },

    handleSubmit () {
      this.setSendingStatus(true)
      this.undo = false
      this.dontSaveDraft = true
      this.updateMessageForm({mailbox_id: this.mailbox.id})
      if (this.parentMessage) {
        this.updateMessageForm({message_id: this.parentMessage.id})
      }
      if (!this.message_id && this.messageForm.to_email.length === 0) {
        alert('No recipient selected')
        return
      }

      if (!this.messageForm.content.length > 0) {
        alert('No email content')
        return
      }

      if (this.updates > 0) {
        this.trafficAlert = true
        this.reloadMessage()
        return
      }

      if (new RegExp('attached|attachment', 'i').test(this.messageForm.content) && this.messageForm.attachments.length < 1) {
        if (!confirm('You mentioned an attachment in the message but no attachments are found. Continue?')) {
          return
        }
      }

      this.showUndoAlert()
      setTimeout(() => {
        if (!this.undo) {
          this.sendMessage()
            .then((response) => this.submitSuccessful(response))
            .catch(e => {})
        }
      }, 5000)
    },

    submitSuccessful (response) {
      this.dontSaveDraft = false
      this.submitButtonText = 'Send'
      this.resetMessage()
      if (this.parentMessage && this.parentMessage.id) {
        this.$root.$emit('toggleReply', {})
        this.reloadMessage()
      } else {
        this.$root.$emit('bv::hide::modal', 'newMessage')
        this.$router.push('/messages/' + response.data.id)
      }
    },

    saveDraft (autoSave) {
      var range = this.editor.getSelection()
      if (range) {
        this.textSelection = range
      }
      if (this.dontSaveDraft) { return false }
      if (this.messageForm.content.length > 0) {
        let parentId = null
        if (this.parentMessage && this.parentMessage.id && !this.forwardedMessage) {
          parentId = this.parentMessage.id
        }
        this.saveDraftMessage({draft: this.draftForm, parentMessageId: parentId}).then(response => this.saveDraftSuccessful(response, autoSave))
      }
    },

    saveDraftSuccessful (response, autoSave) {
      setTimeout(function () {
        this.draftButtonText = 'Save draft'
        if (autoSave) {
          this.showAutoSaveIcon = true
        }
      }.bind(this), 1500)
      if (autoSave) {
        if (this.parent !== 'modal') {
          this.reloadMessage()
          this.editorContent = this.messageForm.content
        }
      } else {
        this.resetMessage()
        if (this.parentMessage && this.parentMessage.id) {
          this.$root.$emit('toggleReply', {})
          this.reloadMessage()
        } else {
          this.$root.$emit('bv::hide::modal', 'newMessage')
        }
      }
    },

    resetMessage () {
      this.editorContent = ''
      this.content = ''
      if (this.editor && this.editor.setContents) {
        this.editor.setContents([{ insert: '\n' }])
      }
      this.setDefaultMessageForm()
      this.setDefaultDraft()
      this.undoCountdown = 0
      this.showAutoSaveIcon = false
      this.draftButtonText = 'Save draft'
    },

    getParentData () {
      if (this.draft.id) {
        this.updateMessageForm({
          to_email: this.draft.to_email,
          cc: this.draft.cc,
          message_id: this.draft.message_id,
          subject: this.draft.subject,
          content: this.draft.content,
          attachments: this.draft.all_attachments || []
        })
        this.editorContent = this.draft.content
      } else if (!this.draft.id && this.parentMessage) {
        if (this.parentMessage.customer) {
          this.updateMessageForm({
            to_email: [this.parentMessage.customer.email]
          })
        }
        if (this.parentMessage.cc_emails) {
          this.updateMessageForm({cc: this.parentMessage.cc_emails})
        }
        this.updateMessageForm({
          subject: this.parentMessage.subject,
          status: this.parentMessage.status,
          user: this.parentMessage.user,
          content: ''
        })
        this.updateMessageForm({message_id: this.parentMessage.id})
      } else {
        this.resetMessage()
      }
    },

    discardDraft () {
      if (this.draft.id) {
        var discard = confirm('Discard this draft?')
        if (discard === true) {
          this.deleteDraft().then(response => {
            if (!this.parentMessage) {
              this.resetMessage()
              this.$root.$emit('bv::hide::modal', 'newMessage')
              this.$router.push('/inboxes/' + this.mailbox.id)
            }
          })
        }
      } else {
        this.resetMessage()
        if (this.parentMessage) {
          this.$root.$emit('toggleReply')
        } else {
          this.$root.$emit('bv::hide::modal', 'newMessage')
        }
      }
    },

    clearListeners () {
      this.$root.$off('toggleReply', this.getParentData)
    },

    showUndoAlert () {
      this.undoCountdown = this.dismissSecs
    },

    dismissUndoAlert () {
      this.undoCountdown = 0
      this.undo = false
    },

    undoSend () {
      this.undo = true
      this.undoCountdown = 0
      this.submitButtonText = 'Send'
    },

    countDownChanged (undoCountdown) {
      this.undoCountdown = undoCountdown
    },

    autoSaveDraft: _.debounce(function () {
      if (this.messageForm.content.length > 0 && this.messageForm.content.replace(/\s/g, '') !== '' && this.submitButtonText !== 'Sending...') {
        this.saveDraft(true)
      }
    }, 15000)
  },

  mounted () {
    this.initialKey++
  },

  beforeDestroy () {
    this.resetMessage()
    this.setDefaultDraft()
  },

  destroyed () {
    this.clearListeners()
  },

  watch: {
    mailbox: function () {
      this.updateMessageForm({mailbox_id: this.mailbox.id})
      this.getSavedReplies()
    },
    'draft.id': function () {
      this.getParentData()
      this.editorContent = this.messageForm.content
      this.textSelection = {}
    }
  }
}
</script>

<style>
  .ql-container.ql-snow {
    border-style: solid !important;
    border-width: 1px 1px 0px 1px !important;
    border-color: gray !important;
  }
  .editorSignature {
    border-style: solid;
    border-width: 0px 1px 1px 1px;
    border-color: gray;
    padding-left: 10px;
  }
  .editorSignature p {
    line-height: 2pt;
    font-size: 10pt;
  }
  .ql-attachment:before {
    background-image: url(/static/images/attachment.svg);
    background-repeat: no-repeat;
    background-size: contain;
    float: right;
    width: 14px;
    height: 14px;
    display: block;
    content: '';
  }

  .ql-saved-replies {
    background-image: url(/static/images/chat-icon.svg);
    background-repeat: no-repeat;
    background-size: contain;
    width: 17px;
    height: 17px;
    display: block;
    content: '';
    position: relative;
    top: 5px;
  }

  .ql-saved-replies .ql-picker-label {
    position: relative;
    top: -8px;
  }

  .inline-v-select .dropdown-toggle {
    height: 40px;
    min-width: 115px;
  }
  .inline-user-select > .multiselect {
    line-height: 22px;
  }
  .alert {
    text-align: left;
  }
  .new-message-form  {
    margin: 15px;
  }
</style>
<style scoped>
  .message-input {
    background: #FFF;
    background: linear-gradient(45deg, rgba(240,249,255,0) 0%,rgba(207,236,255,0.74) 77%,rgba(203,235,255,0.74) 86%,rgba(161,219,255,0.74) 100%);
  }
  .new-message-row{
    margin-bottom: 10px;
  }
  .new-message-row > label {
    margin: 0px;
  }
  .btn-outline-info {
    color: #57B2CD;
    border-color: #57B2CD;
  }
  .btn-outline-info:hover {
    color: #FFF;
    background-color: #57B2CD;
    border-color: #57B2CD;
  }
  .new-message-actions {
    display: flex;
    justify-content: space-between;
    margin: 5px 0px 10px 0px;
  }
  .change-user-status {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
  }
  .change-user-status > li {
    margin: 0 0 0 5px;
    display: inline-block;
    line-height: 18px;
    float: right;
    flex: 1
  }
  .change-user-status > li > label {
    vertical-align: middle;
    line-height: 24px;
    display: inline-block;
    margin-bottom: 0px;
  }
  .inline-v-select {
    display: inline-block;
  }
  #quillImage {
    display: none
  }
  .new-message-buttons {
    display: flex;
    padding: 0;
  }
  .message-button-item {
    margin-right: 5px;
    flex: 1;
  }
  .draft-saved {
    color: #01C16F;
    font-size: 25px;
  }
  @media (max-width: 767px) {
    .change-user-status {
      margin: 5px 0 0 0;
    }
    .change-user-status > li {
      float: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewMessage.vue